import React from "react";
import { Recommended } from "components/buckets/shard-cluster-section/recommended";
import DetailsPanel from "components/shared-ui/details-panel/details-panel";

export interface ITemplatePanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export const TemplatePanel = ({ isOpen, onClose }: ITemplatePanelProps) => {
  return (
    <DetailsPanel
      open={isOpen}
      title="Shard Cluster Deployment Template"
      onCloseClick={onClose}
      autoFocus
    >
      <Recommended bucketName="bucket" onChange={() => {}} />
    </DetailsPanel>
  );
};
